import React, {ComponentPropsWithRef, useContext} from 'react';

export type DialogType = 'modal' | 'popover' | 'tray';

export interface DialogContextValue<T = unknown> {
  labelId: string;
  descriptionId: string;
  type: DialogType;
  isDismissable?: boolean;
  close: (value?: T) => void;
  value: T;
  setValue: (value: T) => void;
  initialValue: T;
  formId: string;
  dialogProps: ComponentPropsWithRef<'div'>;
  disableInitialTransition?: boolean;
}

export const DialogContext = React.createContext<DialogContextValue>(null!);

export function useDialogContext<T = unknown>() {
  const context = useContext(DialogContext);
  if (!context) {
    // Return a safe fallback when context is not available
    return {
      labelId: '',
      descriptionId: '',
      type: 'modal' as DialogType,
      isDismissable: true,
      close: () => {},
      value: undefined as T,
      setValue: () => {},
      initialValue: undefined as T,
      formId: '',
      dialogProps: {},
      disableInitialTransition: false,
    } as DialogContextValue<T>;
  }
  return context as DialogContextValue<T>;
}
